import { useState, useEffect } from 'react'
import { useNavigate, Outlet } from 'react-router-dom'
import http from 'http'
import { withProfile } from 'context/Profile'

import {
  FiMap,
  FiArrowLeft,
  FiSearch,
  FiChevronsLeft,
  FiChevronLeft,
  FiChevronsRight,
  FiChevronRight,
  FiFilter,
} from 'react-icons/fi'

const Paths = ( {
  withProfile: { user }
} ) => {
  const navigate = useNavigate()
  const [ routeList, setRouteList ] = useState()
  const [ total, setTotal ] = useState()

  const [ options, setOptions ] = useState( {
    __as: 'page',
    __match: { by: user.id },
    __sort: { at: -1 },
    __limit: 10,
    __offset: 0
  } )

  useEffect( () => {
    http( {
      method: 'POST',
      url: '/mongo/findMany',
      data: {
        __model: 'Route',
        __select: {
          name: 1
        },
        ...options
      }
    } )
      .then( ( { data } ) => {
        setRouteList( data.page )
        setTotal( data.total )
      } )

  }, [ options ] )

  const back = () => {
    navigate( '/main' )
  }

  const search = () => {
    console.log( 'search' )
  }

  const next = () => {
    const offset = options.__offset + options.__limit
    if ( offset < total )
      setOptions( { ...options, __offset: offset } )
  }

  const prev = () => {
    const offset = options.__offset - options.__limit
    if ( offset >= 0 )
      setOptions( { ...options, __offset: offset } )
  }

  const first = () => {
    if ( options.__offset === 0 )
      return

    setOptions( { ...options, __offset: 0 } )
  }

  const last = () => {
    const rest = total % options.__limit
    let offset = 0

    if ( rest > 0 )
      offset = total - rest
    else
      offset = total - options.__limit

    if ( offset === options.__offset )
      return

    setOptions( { ...options, __offset: offset } )
  }

  const openRoute = ( route ) => {
    const to = `/routes/${ route._id }`

    navigate( to )
  }
 
  if ( ! routeList )
    return null

  return <section className="one hs air-2x gap-2x">

    <div className="bar">
      <button
        onClick={ back }
      >
        <FiArrowLeft />
      </button>

      <input
        size={ 1 }
        placeholder="routes"
      />

      <button
        onClick={ search }
      >
        <FiSearch />
      </button>

      <button
        onClick={ search }
      >
        <FiFilter />
      </button>
    </div>

    <ul className="list-menu">
      { routeList.map( ( route, ix ) => <li
        key={ ix }
        className="list-item"
        onClick={ () => openRoute( route ) }
      >
        <span className="icon">
          <FiMap />
        </span>

        <span className="one text">
          { route.name }
        </span>
      </li> ) }

    </ul>

    <div className="bar">
      <button
        onClick={ first }
      >
        <FiChevronsLeft />
      </button>

      <button
        onClick={ prev }
      >
        <FiChevronLeft />
      </button>

      <h1 className="ta-center">
        { options.__offset + 1 }
        &nbsp;
        -
        &nbsp;
        { ( options.__offset + options.__limit ) < total ? options.__offset + options.__limit : total }
        &nbsp;
        /
        &nbsp;
        { total }
      </h1>

      <button
        onClick={ next }
      >
        <FiChevronRight />
      </button>

      <button
        onClick={ last }
      >
        <FiChevronsRight />
      </button>
    </div>

    <Outlet />
  </section>
}

export default withProfile( Paths )
